import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabCasinoPage } from './tab-casino.page'
import { TabCasinoPageRoutingModule } from './tab-casino-routing.module';
import { CasinoLobbyModule } from '../../components/casino-lobby/casino-lobby.module';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    TabCasinoPageRoutingModule,
    CasinoLobbyModule,
    ComponentsModule,    
  ],
  declarations: [TabCasinoPage]
})
export class TabCasinoPageModule {}
